<template>
  <div class="house">
    <div class="header">
      <div class="search" style="width: 60%">
        <el-input
          class="search-input"
          v-model="searchValue"
          placeholder="请输入要查询关键字"
        ></el-input>
        <el-button @click="onSearch" icon="el-icon-search" size="small"
          >查询</el-button
        >
        <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
          >刷新</el-button
        >
      </div>
      <div>
        <el-button-group>
          <!-- 导出 -->
          <PermissionsBtn
            :icon="'el-icon-download'"
            :btnType="'primary'"
            :permissionName="'_Export'"
            :downloadUrl="'/productAdmin/House/downLoad_house'"
            :checkList="checkList"
            :form="{ name: searchValue }"
          ></PermissionsBtn>
          <el-button
            style="margin: 0 10px"
            type="primary"
            icon="el-icon-plus"
            @click="onAdd"
            v-if="roleList[path].includes('_Add')"
            >新增</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-upload2"
            style="margin: 0 10px"
            @click="openImport"
            v-if="roleList[path].includes('_Import')"
            >导入</el-button
          >
        </el-button-group>
        <el-dropdown>
          <el-button type="success">
            更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              @click.native="onChange('open', '开启楼盘')"
              v-if="roleList[path].includes('_Open')"
              >开启楼盘</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="onChange('close', '关闭楼盘')"
              v-if="roleList[path].includes('_Close')"
              >关闭楼盘</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="onChange('recommend', '设置热门')"
              v-if="roleList[path].includes('_Set_recommend')"
              >设置热门</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="onChange('norecommend', '取消热门')"
              v-if="roleList[path].includes('_Cancel_recommend')"
              >取消热门</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="onChange('fore', '设置预告')"
              v-if="roleList[path].includes('_Set_preview')"
              >设置预告</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="onChange('nofore', '取消预告')"
              v-if="roleList[path].includes('_Cancel_preview')"
              >取消预告</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      height="750"
      style="width: 100%"
      :data="houseData"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
    >
      <el-table-column align="center" width="50" label="编号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->

      <el-table-column label="楼盘图" width="100" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.houseImg" style="width: 100%" />
        </template>
      </el-table-column>

      <el-table-column label="楼盘名称" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName }}
        </template>
      </el-table-column>

      <el-table-column label="区域" align="center">
        <template slot-scope="scope">
          {{ scope.row.areaId | filterArea }}
        </template>
      </el-table-column>

      <el-table-column label="楼盘标签" align="center">
        <template slot-scope="scope">
          {{ scope.row.propertyTag }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="楼盘简介" align="center">
                <template slot-scope="scope">
                    {{ scope.row.remark }}
                </template>
            </el-table-column> -->

      <el-table-column label="开盘时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.openingTime }}
        </template>
      </el-table-column>
      <el-table-column label="面积信息" align="left" width="140">
        <template slot-scope="scope">
          占地面积: {{ scope.row.areaSpace }}<br />
          绿化面积: {{ scope.row.greenSpace }}<br />
          户型面积: {{ scope.row.roomArea }}<br />
          绿化率: {{ scope.row.greenRate }}<br />
          容积率: {{ scope.row.volumeRate }}<br />
        </template>
      </el-table-column>

      <el-table-column label="楼盘信息" align="left" width="150">
        <template slot-scope="scope">
          楼盘地址: {{ scope.row.address }}<br />
          产权: {{ scope.row.property }}<br />
          出售价格: {{ scope.row.price }}<br />
          出租价格: {{ scope.row.leasePrice }}<br />
          售楼电话: {{ scope.row.phone }}<br />
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="经纬度" align="center">
        <template slot-scope="scope">
          经度: {{ scope.row.lng }}<br />
          纬度: {{ scope.row.lat }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="是否开启" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isOpen ? 'success' : 'info'">{{
            scope.row.isOpen ? '是' : '否'
          }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="是否热门" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isHot ? 'success' : 'info'">{{
            scope.row.isHot ? '是' : '否'
          }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="是否预告" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.houseStatus == 0 ? 'success' : 'info'">{{
            scope.row.houseStatus == 0 ? '是' : '否'
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="客服通知人数"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.houseCustomerCount }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="销售通知人数"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.houseSalesCount }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="财务复核人数"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.houseReviewCount }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="未复核佣金数"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.houseUnReviewCount }}
        </template>
      </el-table-column>

      <!-- <el-table-column class-name="status-col" label="添加人" align="center">
                <template slot-scope="scope">
                    {{ scope.row.createBy }}
                </template>
            </el-table-column> -->
      <!-- <el-table-column class-name="status-col" xlabel="添加时间" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.createTime.split(' ')[0] }}</div>
                    <div>{{ scope.row.createTime.split(' ')[1] }}</div>
                </template>
            </el-table-column> -->
      <!-- <el-table-column class-name="status-col" label="修改人" align="center">
                <template slot-scope="scope">
                    {{ scope.row.updateBy }}
                </template>
            </el-table-column> -->
      <!-- <el-table-column class-name="status-col" label="修改时间" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.updateTime.split(' ')[0] }}</div>
                    <div>{{ scope.row.updateTime.split(' ')[1] }}</div>
                </template>
            </el-table-column> -->

      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="edit(scope)"
            v-if="roleList[path].includes('_Update')"
            >编辑楼盘</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="editDes(scope)"
            v-if="roleList[path].includes('_Edit_description')"
            >编辑描述</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="editRate(scope)"
            v-if="roleList[path].includes('_Edit_commission')"
            >编辑佣金</el-button
          >

          <el-button
            type="text"
            size="mini"
            @click="editGroup(scope)"
            v-if="roleList[path].includes('_Edit_picture')"
            >编辑图片</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="deleteItem(scope)"
            v-if="roleList[path].includes('_Update')"
            >删除楼盘</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="getHouseNews(scope)"
            v-if="roleList[path].includes('_Check_dynamic')"
            >查看动态</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="handleNotification(scope.row)"
            v-if="roleList[path].includes('_Noti_setting')"
            >通知设置</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />

    <!-- 修改表单对话框 -->
    <editHouses ref="editHouses" :areaData="areaData" />

    <!-- 楼盘描述 -->
    <wangEditor ref="wangEditor" />

    <!-- 修改佣金对话框 -->
    <editFromRate ref="editFromRate" />

    <!-- 编辑消息通知 -->
    <notifiactionTabs ref="notifiactionTabs" />

    <!-- 佣金列表对话框 -->
    <commissionTypesList ref="commissionTypesList" />

    <!-- 修改表单对话框 -->
    <editFromGroup ref="editFromGroup" />
    <!-- 导入对话框-->
    <importForm ref="importForm" @getList="getList" />
  </div>
</template>

<script>
// import { getList } from '@/api/table'
// import wangEditor from './wangEditor' // 富文本编辑组件
import Pagination from '@/components/Pagination'; // 分页
const editHouses = () => import('./editHouses'); // 编辑表单
const wangEditor = () => import('./wangEditor'); // 编辑表单
const editFromRate = () => import('./editFromRate'); // 编辑佣金
const notifiactionTabs = () => import('./notifiactionTabs'); // 通知设置
const editFromGroup = () => import('./editFromGroup'); // 编辑表单
const commissionTypesList = () => import('./commissionTypesList'); // 佣金列表
const importForm = () => import('./ImportForm'); //导入

import { getCityList } from '@/api/areaApi.js';
import { houseList, houseRemove, houseChange } from '@/api/houseApi.js';
import { mapGetters } from 'vuex';

var that;
export default {
  components: {
    Pagination,
    editHouses,
    wangEditor,
    editFromRate,
    notifiactionTabs,
    editFromGroup,
    commissionTypesList,
    importForm,
  },
  inject: ['reload'],
  data() {
    return {
      listLoading: false,
      houseData: [],
      areaData: [],
      pageIndex: '',
      pageSize: 10,
      path: '',
      multipleSelection: [],
      searchValue: '',
      checkList: [], // 选中的列表
    };
  },
  computed: {
    ...mapGetters(['checkNodeData', 'paginObj', 'roleList']),
  },
  beforeCreate() {
    that = this;
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  mounted() {
    this.getArea();
    this.getList();
  },
  filters: {
    filterArea: function (id) {
      let name = '';
      that.areaData.forEach((item) => {
        if (item.areaId === id) {
          name = item.areaName;
        }
      });
      return name;
    },
  },
  watch: {
    checkNodeData: 'getList',
    paginObj: 'getList',
  },
  methods: {
    openImport() {
      this.$refs.importForm.dialogFormVisible = true;
    },
    // 获取城市
    getArea() {
      getCityList().then((res) => {
        this.areaData = res.data.dataList;
      });
    },
    // 获取楼盘
    getList() {
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      try {
        this.listLoading = true;
        houseList({
          areaId:
            this.checkNodeData.data === undefined
              ? areaId
              : this.checkNodeData.data.areaId,
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          name: this.searchValue,
        }).then((res) => {
          localStorage.setItem(
            'areaId',
            JSON.stringify({
              areaId:
                this.checkNodeData.data === undefined
                  ? areaId
                  : this.checkNodeData.data.areaId,
            })
          );
          this.houseData = res.data.dataList;
          this.pageIndex = res.data.pageIndex;
          this.pageSize = res.data.pageSize;
          this.listLoading = false;
          this.$refs.Pagination.pageSize = res.data.pageSize;
          this.$refs.Pagination.pageIndex = res.data.pageIndex;
          this.$refs.Pagination.totalCount = res.data.totalCount;
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.checkList = val.map((item) => {
        return item.houseId;
      });
    },
    // 搜索
    onSearch() {
      this.getList();
    },
    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 增加
    onAdd() {
      this.$refs.editHouses.houseId = '';
      this.$refs.editHouses.dialogTitle = '新增楼盘';
      this.$refs.editHouses.dialogFormVisible = true;
    },
    // 单条编辑
    edit(scope) {
      this.$refs.editHouses.houseId = scope.row.houseId;
      this.$refs.editHouses.dialogTitle = '编辑楼盘';
      this.$refs.editHouses.dialogFormVisible = true;
      // this.$refs.editHouses.source = scope.row.code ? 2 : 1;
      // console.log('housePdf', scope.row.housePdf);
      if (scope.row.housePdf) {
        this.$refs.editHouses.editForm.housePdf = scope.row.housePdf;
        this.$refs.editHouses.pdfFileList.push({
          name: this.getValue(scope.row.housePdf),
          url: scope.row.housePdf,
        });
      }
      // console.log('pdfFileList', this.$refs.editHouses.pdfFileList);
      // console.log('row', this.$refs.editHouses.editForm.source);
      this.$refs.editHouses.editForm = JSON.parse(JSON.stringify(scope.row));
      // console.log('form', this.$refs.editHouses.editForm);

      if (scope.row.houseType != null) {
        this.$refs.editHouses.houseTypeArr = scope.row.houseType.split(',');
      } else {
        this.$refs.editHouses.houseTypeArr = [];
      }
    },
    getValue(url) {
      if (!url) return;
      //获取最后一个/的位置
      var site = url.lastIndexOf('/');
      //截取最后一个/后的值
      return url.substring(site + 1, url.length);
    },
    // 单条编辑
    editDes(scope) {
      this.$refs.wangEditor.houseId = scope.row.houseId;
      this.$refs.wangEditor.dialogFormVisible = true;
    },
    // 编辑通知设置
    handleNotification({ houseId, houseName }) {
      this.$refs.notifiactionTabs.houseId = houseId;
      this.$refs.notifiactionTabs.houseName = houseName;
      this.$refs.notifiactionTabs.dialogTableVisible = true;
    },
    // 编辑佣金
    editRate(scope) {
      // console.log(scope.row, 'lalala');
      let { houseId, houseName } = scope.row;
      this.$refs.commissionTypesList.houseId = houseId;
      this.$refs.commissionTypesList.houseName = houseName;
      // this.$refs.editHouses.IsOverdue = scope.row.IsOverdue;
      // this.$refs.editFromRate.dialogFormVisible = true;

      this.$refs.commissionTypesList.dialogTableVisible = true;
    },
    editGroup(scope) {
      this.$refs.editFromGroup.houseId = scope.row.houseId;
      this.$refs.editFromGroup.dialogFormVisible = true;
    },
    // 单条删除
    deleteItem(scope) {
      const item = scope.row;
      let checkIds = [];
      checkIds.push(item.houseId);
      this.funcRemove(checkIds);
    },
    //查看楼盘动态
    getHouseNews(scope) {
      let houseId = scope.row.houseId;
      this.$router.push({
        path: 'houseNews',
        query: { id: houseId },
      });
    },

    // 勾选编辑
    onEdit() {
      if (this.multipleSelection.length === 0)
        return this.$message.error('请选择要编辑的数据');
      if (this.multipleSelection.length > 1)
        return this.$message.error('请选择要编辑的单条数据');
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.editForm = JSON.parse(
        JSON.stringify(this.multipleSelection)
      );
      if (this.multipleSelection[0].houseType != null) {
        this.$refs.editHouses.houseTypeArr =
          this.multipleSelection[0].row.houseType.split(',');
      } else {
        this.$refs.editHouses.houseTypeArr = [];
      }
    },
    // 勾选改变
    onChange(ty, title) {
      let checkIds = [];
      this.multipleSelection.forEach((item) => {
        checkIds.push(item.houseId);
      });
      try {
        if (checkIds.length === 0)
          return this.$message.error('请选择要设置的数据');
        this.$confirm(`是否确认${title}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await houseChange(ty, checkIds).then((res) => {
              if (res.code === 200) {
                this.onRefresh();
                this.$message.success('设置成功!');
              } else {
                this.$message.info('设置失败：' + res.message);
              }
            });
          })
          .catch(() => {
            console.log('取消');
          });
      } catch (e) {
        this.$message.info('设置出错:' + e.message);
        window.console.log(e);
      }
    },
    // 勾选删除
    onRemove() {
      let checkIds = [];
      this.multipleSelection.forEach((item) => {
        checkIds.push(item.houseId);
      });
      this.funcRemove(checkIds);
    },
    funcRemove: function (checkIds) {
      try {
        if (checkIds.length === 0)
          return this.$message.error('请选择要删除的数据');
        this.$confirm('是否狠心删除该数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await houseRemove(checkIds).then((res) => {
              if (res.code === 200) {
                this.onRefresh();
                this.$message.success('删除成功!');
              } else {
                this.$message.info('删除失败：' + res.message);
              }
            });
          })
          .catch(() => {});
      } catch (e) {
        this.$message.info('删除出错:' + e.message);
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.house {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 800px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}
.btn {
  display: flex;
  align-items: center;
}

/deep/ .el-button + .el-button {
  margin-left: 0;
}
</style>
